export default __webpack_public_path__ + "static/media/gallery_05.b22e0d2a.jpg";